// axios
import { apiPharmaInstance } from 'utils/axios';

export const sendRequestCdO = async (posId: any) => {
    const response = await apiPharmaInstance.post(`/api/points-of-sale/${posId}/cdo-signup`);
    return response.data;
};
